/**
 * Bangla digits on Bangla pages (Multilang_Culture_Spec.md 8), worklybd's way (worklybd_ui/src/lib/banglaDigits.ts): a
 * small font that draws ০-৯ on the ordinary 0-9, for those ten characters only. The text keeps 0-9, so copying,
 * searching, inputs, analytics and the values sent to the API do not change, and prices read ৳১,২৯৯.
 *
 * The faces are a family of their own, which the site's CSS puts first where digits are to be Bangla (PrimeHat: prices,
 * totals, dates, quantities and counts; product names and order numbers keep 0-9); every other character falls through
 * to the next font. Written into the head by the server render of a Bangla page, so its first paint has them; never on
 * any other page. font-display swap: until a face arrives a price shows 0-9, never nothing; the regular face is preloaded.
 */
export interface BanglaDigitsConfig {
    /** The digits' family, as the site's CSS names it: 'PrimeHat Bangla Digits'. */
    family: string;
    /** The font files, with {name} for the weight's name: '/assets/fonts/bangla-digits/SiteBanglaDigits-{name}.otf'. */
    files: string;
}

export const BANGLA_DIGITS_STYLE_ID = 'culture-bangla-digits';

const WEIGHTS: { [weight: number]: string } = { 300: 'Light', 400: 'Regular', 500: 'Medium', 600: 'SemiBold', 700: 'Bold' };

export function banglaDigitsCss(config: BanglaDigitsConfig): string {
    return Object.keys(WEIGHTS).map(weight =>
        `@font-face{font-family:'${config.family}';font-style:normal;font-weight:${weight};font-display:swap;` +
        `src:url(${config.files.replace('{name}', WEIGHTS[+weight])}) format('opentype');unicode-range:U+0030-0039;}`
    ).join('\n');
}

/** The face most digits are drawn in, preloaded with the page. */
export function banglaDigitsRegular(config: BanglaDigitsConfig): string {
    return config.files.replace('{name}', WEIGHTS[400]);
}

export function addBanglaDigits(document: Document, config: BanglaDigitsConfig): void {
    if (!document || !config || document.getElementById(BANGLA_DIGITS_STYLE_ID)) { return; }
    const style = document.createElement('style');
    style.id = BANGLA_DIGITS_STYLE_ID;
    style.textContent = banglaDigitsCss(config);
    document.head.appendChild(style);
}
